import type { FC } from 'react';
import { SITE } from '@/app/constants';
import type { T2AImage } from '@/app/types';
import { cn } from '@/app/utils';
import { useLocale } from '@/i18n/routing';

interface AudioCardProps {
  audioImage?: T2AImage;
  prompt?: string;
}

export const AudioCard: FC<AudioCardProps> = ({ audioImage, prompt }) => {
  const locale = useLocale();

  return (
    <div
      className="group relative size-full cursor-pointer overflow-hidden rounded-8 bg-center bg-cover"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${audioImage?.cover[SITE]})`,
      }}
    >
      {prompt && (
        <div className="absolute right-2 bottom-2 left-2 flex justify-between">
          <div
            className={cn(
              'mr-3 line-clamp-3 flex-1 font-semibold text-[20px] text-white leading-[1.4]',
              locale !== 'en' && 'mb-2 ml-2',
            )}
          >
            {prompt}
          </div>
        </div>
      )}
    </div>
  );
};
